import {
  Empty,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  EmptyDescription,
  Icon,
} from "@salestrak/ui";

interface InboxEmptyStateProps {
  activeTab: "all" | "cleared";
}

export function InboxEmptyState({ activeTab }: InboxEmptyStateProps) {
  return (
    <Empty>
      <EmptyMedia>
        <Icon
          name={activeTab === "all" ? "inbox" : "archive"}
          size="2xl"
          color="muted"
        />
      </EmptyMedia>
      <EmptyHeader>
        <EmptyTitle>
          {activeTab === "all" ? "Inbox Empty" : "No cleared notifications"}
        </EmptyTitle>
        <EmptyDescription>
          {activeTab === "all"
            ? "Check back later for updates or important notifications"
            : "Clear a notification to find it here"}
        </EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
}
